import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const IconExpediente = (props) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={27} {...props}>
    <Path
      fill="#001689"
      d="M0 3.25A3.25 3.25 0 0 1 3.25 0h8.4a3.24 3.24 0 0 1 2.3.952l4.6 4.6a3.239 3.239 0 0 1 .95 2.3v14.9A3.253 3.253 0 0 1 16.25 26h-13A3.251 3.251 0 0 1 0 22.75Zm17.063 19.5V8.125H13A1.623 1.623 0 0 1 11.375 6.5V2.438H3.25a.812.812 0 0 0-.812.813v19.5a.814.814 0 0 0 .813.813h13a.815.815 0 0 0 .812-.814Z"
    />
  </Svg>
);
export default IconExpediente;
